/**
 * Created by Yoyo Fang on 05/05/19.
 * Description:
 *
 * ------ maintenance history ------
 */

import { of as observableOf, Observable, of } from 'rxjs';

import { map, catchError, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { EntityService } from '../../tamalelibs/services/entity.service';
import { DELETE_ENTITY, DELETE_ENTITY_FAIL, DELETE_ENTITY_SUCCESS, RELOAD_ENTITIES, RELOAD_ENTITIES_FAIL, RELOAD_ENTITIES_SUCCESS } from '../../tamalelibs/redux/entity-list.actions';
import { EntityListAction } from '../../tamalelibs/components/entity-list.config';
import { smartEffect } from '../index';

@Injectable()
export class EntityListEffects {

    constructor(private _actions$: Actions, private _entityService: EntityService) { }

    getEntityListEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(RELOAD_ENTITIES),
        map(action => action as EntityListAction),
        switchMap((action: EntityListAction) => {
            const payload = action.payload;
            return this._entityService.searchEntityList(payload.page, payload.pageSize, payload.keyword).pipe(
                map(response => {
                    const entityList = this._entityService.mapEntityList(response);
                    return smartEffect(action, {
                        type: RELOAD_ENTITIES_SUCCESS,
                        payload: entityList,
                        params: payload
                    });
                }),
                catchError(err => {
                    return observableOf({ type: RELOAD_ENTITIES_FAIL, payload: err.message });
                }));
        }
        )));

    deleteContactEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(DELETE_ENTITY),
        switchMap((action: any) => {
            const entityId = action.payload;
            return this._entityService.deleteEntityById(entityId).pipe(
                map((entity) => {
                    return {
                        type: DELETE_ENTITY_SUCCESS,
                        payload: entity
                    };
                }),
                catchError(err => {
                    return of({
                        type: DELETE_ENTITY_FAIL
                    });
                }),
            );
        })
    ));
}
